const ACTIVE_MUNICIPALITY_KEY = "ordinal:active_municipality_id";

export function readActiveMunicipalityId(): number | undefined {
  try {
    const raw = localStorage.getItem(ACTIVE_MUNICIPALITY_KEY);
    if (!raw) return undefined;
    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
  } catch {
    return undefined;
  }
}

export function writeActiveMunicipalityId(id: number): void {
  try {
    localStorage.setItem(ACTIVE_MUNICIPALITY_KEY, String(id));
  } catch {
    // ignore quota / private mode
  }
}
